import { hideLoading, isLoadingVisible, showLoading } from '@/mixins/ui-mixin';
import { showSignWithQrCodeDialog } from '@/plugins/dialogs';
import { EventBus } from '@/helpers/event-bus';
import { logger } from '@/helpers/log.service';
import { AppSignKeyOperationType, EndUserEventType } from '@/sign/models/sign-constants';

export async function executeCloudSignOperationWithConfirmationByQrCode(
  cloudProvider: string,
  euSignLib: any,
  operationName: string,
  operationParams: Array<any>,
  privateKeyType: string,
  keyOperationType: AppSignKeyOperationType,
  mobileAppName?: string
): Promise<any> {
  logger.debug(`[executeCloudSignOperationWithConfirmationByQrCode] cloudProvider="${cloudProvider}" privateKeyType="${privateKeyType}" keyOperationType=${keyOperationType} mobileAppName="${mobileAppName}" operation="${operationName}" params: `, operationParams);

  let operationResult: any;
  let loaderVisible = isLoadingVisible();
  let closeDlgFn = () => {
    EventBus.$emit('app-sign-with-qrcode-dlg-close');
    if (loaderVisible) showLoading({}, true);
  };

  try {
    let resolveFn: (value?: unknown) => void = () => {};
    let rejectFn: (reason: any) => void = () => {};
    let signPromise = new Promise((resolve, reject) => {
      resolveFn = resolve;
      rejectFn = reject;
    });

    await euSignLib.AddEventListener(
      EndUserEventType.ConfirmKSPOperation,
      async(ev: any) => {
        logger.debug(`[euSignLib:EventListener] event`, ev);

        if (ev && ev.url) {
          if (loaderVisible) await hideLoading();

          EventBus.$on('app-sign-with-qrcode-dlg-cancelled', async() => {
            closeDlgFn();
            await euSignLib.ResetPrivateKey();
            rejectFn('cancelled');
          });

          let urlLifeTimeSec = ev.expireDate
            ? Math.round((ev.expireDate - Date.now()) / 1000)
            : 180;

          showSignWithQrCodeDialog({
            deepLink: ev.url,
            deepLinkLifeTimeSeconds: urlLifeTimeSec,
            cloudProvider: cloudProvider,
            privateKeyType: privateKeyType,
            keyOperationType: keyOperationType,
            mobileAppName: mobileAppName
          });
        } else {
          await euSignLib.ResetPrivateKey();
          rejectFn(new Error('Cannot make a Qr code due to incorrect parameter of the KSP operation event'));
        }
      }
    );

    euSignLib[operationName].apply(euSignLib, operationParams).then(resolveFn).catch(rejectFn);
    operationResult = await signPromise;
  } catch (err) {
    throw err;
  } finally {
    closeDlgFn();
    EventBus.$off('app-sign-with-qrcode-dlg-cancelled');
    await euSignLib.AddEventListener(EndUserEventType.ConfirmKSPOperation, () => { });
  }
  return operationResult;
}
